import PropTypes from 'prop-types';
import * as React from 'react';

import SavableComponentContainer from '../SavableComponentContainer';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const TabSetScreenWrapper = ({metadata, screenId}) => (
  <SavableComponentContainer metadata={metadata} screenId={screenId} />
);

TabSetScreenWrapper.displayName = 'TabSetScreenWrapper';

TabSetScreenWrapper.propTypes = {
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
};

export default TabSetScreenWrapper;
